import type { ReactElement } from 'react'
import { Outlet } from 'react-router-dom'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { useLanguagePreference } from '@/hooks/useLanguagePreference'

/** The matched auth page, with the signed-in user's saved UI language applied. */
function SavedLanguageOutlet(): ReactElement {
	// `Layout` is the other place this runs; these pages sit outside it, so
	// without it an es/gl user would get the browser language here (TO-197).
	useLanguagePreference()
	return <Outlet />
}

/**
 * The route group for the authenticated auth surfaces (TO-637, AD-4): forced
 * MFA enrolment, the invitation's federated return leg, onboarding. It only
 * authenticates — no sidebar, no account menu — and each page draws its own
 * frame (`AuthShellView` for the auth screens). Not the plane `AuthShell`
 * frontend-architecture.md describes: this element is non-visual.
 */
export function AuthSurfaceRoute(): ReactElement {
	return (
		<ProtectedRoute>
			<SavedLanguageOutlet />
		</ProtectedRoute>
	)
}
